import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Subscriptions from "../../_components/subscriptions/Subscriptions";
import Loading from "../../../../components/Loading";
import styles from './Builder.module.scss';
import Card from "../../../../components/card/Card";
import CardAdvanced from "../../../../components/card/CardAdvanced";
import ReqCalculator from "../../_background/ReqCalculator";
import NetworkCustom from "./components/NetworkCustom";
import Services from "./components/services/Services";
import ProjectPublish from "./components/publish/ProjectPublish";
import ProjectSettings from "./components/ProjectSettings";
import { useRouter } from "next/router";
import commonStyles from "../common.module.scss";
import RippleLayout from "../../../../components/ripple/RippleLayout";
import ActionsLayout from "../_layouts/ActionsLayout";

function Builder({
                     project, projects,
                     onProjectCreate, projectCreateStatus,
                     onProjectSave, onBuilderConfirm,
                     appsData, messages,
                     categories, tags,
                     requestLoading,
                 }) {

    const router = useRouter();

    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        if (router.isReady) setRefresh(true);
    }, [router.isReady, router.query.project]);

    useEffect(() => {
        if (!!refresh) setTimeout(() => setRefresh(false), 1);
    }, [refresh]);

    if (!!refresh) return (
        <Loading
            className={commonStyles.loading}
            icon={{faCode: 'fas fa-chevron-down', animationType: 'bottom'}}
            message={'Loading project...'}
            type={'component'}
            coverOpacity={0}
        />
    );

    const renderForm = () => (
        <>
            <form className={styles.layout__form} id='deployment-form'>
                <Card
                    title='New Project'
                    style={{marginBottom: '10px'}}
                    id='project-settings'
                    messages={messages}
                >
                    <ProjectSettings
                        categories={categories}
                        tags={tags}
                        messages={messages}
                    />
                </Card>
                <CardAdvanced
                    style={{marginBottom: '10px', width: '100%'}}
                    collapsed={true}
                    title='Networks'
                    id='networks'
                    messages={messages}
                >
                    <NetworkCustom/>
                </CardAdvanced>
                <Card
                    style={{marginBottom: '10px'}}
                    title='Services'
                    id='services'
                    messages={messages}
                >
                    <Services
                        onProjectSave={onProjectSave}
                        apps={[
                            ...appsData.web,
                            ...appsData.service,
                            ...appsData.feature,
                        ]}
                    />
                </Card>
                <Subscriptions custom/>
                <CardAdvanced
                    title='Add to marketplace (Pre-register)'
                    style={{marginBottom: '10px'}}
                    id='project-publish'
                    messages={messages}
                    collapsed
                >
                    <ProjectPublish
                        categories={categories}
                        tags={tags}
                        messages={messages}
                    />
                </CardAdvanced>
            </form>
            <ReqCalculator custom/>
        </>
    );

    const renderCreate = () => (
        <div className={styles.new}>
            {
                !!projects?.length &&
                <div className={styles.new__select}>
                    <i className={`fas fa-reply ${styles.new__select__icon}`}/>
                    <p>Pick a project from left menu</p>
                </div>
            }
            <div className={styles.new__create}>
                <RippleLayout
                    className={styles.new__create__ripple}
                    onClick={onProjectCreate}

                >
                    <p>Create new project</p>
                    <i className={`fas fa-plus`}/>
                </RippleLayout>
            </div>
        </div>
    );

    return (
        <>
            <div className={styles.layout}>
                {
                    (
                        projectCreateStatus === 'success'
                        || projectCreateStatus === undefined
                    ) && (
                        !router.query.project
                        || !!project && !!router.query.project
                    )
                        ? !!project ? renderForm() : renderCreate()
                        :
                        <Loading
                            className={commonStyles.loading}
                            icon={{faCode: 'fas fa-chevron-down', animationType: 'bottom'}}
                            message={'Loading project...'}
                            type={'component'}
                            coverOpacity={0}
                        />
                }
                {
                    !!project &&
                    <ActionsLayout
                        nextTitle={`Continue`}
                        nextDisabled={requestLoading || messages.some(m => m.type === 'error')}
                        nextIcon={`fas fa-chevron-right`}
                        disabledGlobal={requestLoading}
                        loading={requestLoading}
                        nextOnClick={onBuilderConfirm}
                    />
                }
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    requestLoading: state.deployment.requestLoading,
    messages: state.deployment.messages,
});

export default connect(mapStateToProps)(Builder)